import axios from "axios";
import AwsAxios from "../utils/AwsAxios";
import ApiList from "../utils/api_list";
const profile = ApiList.profile;
const preSigned = ApiList.preSigned;
const utils = ApiList.utils;
const login = ApiList.login;
const integrated = ApiList.integrated;
export const generatePreSignedUrl = async (data) => {
  const result = await AwsAxios.post(`${utils}/generate-pre-sign-url`, data);
  return result;
};
export const generatePreSignedUrlWithoutToken = async (data) => {
  const result = await axios.post(`${utils}/potential/pre-signed-url`, data);
  return result;
};
export const getBasicInfo = async () => {
  const result = await AwsAxios.get(`${profile}/basic-info`);
  return result;
};
export const getStreak = async () => {
  const result = await AwsAxios.get(`${profile}/streak-info`);
  return result;
};
export const getCalendarDetails = async () => {
  const result = await AwsAxios.get(`${profile}/calender`);
  return result;
};
export const updateBasicInfo = async (data) => {
  const result = await AwsAxios.post(`${profile}/basic-info`, data);
  return result;
};
export const getEducationalInfo = async () => {
  const result = await AwsAxios.get(`${profile}/educational-info/my-info`);
  return result;
};
export const updateEducationalInfo = async (data) => {
  const result = await AwsAxios.post(`${profile}/educational-info`, data);
  return result;
};
export const addCalenderDetails = async (data) => {
  const result = await AwsAxios.post(`${profile}/calender`, data);
  return result;
};
export const deleteCalenderEvent = async (data) => {
  const result = await AwsAxios.post(`${profile}/calender/delete`, data);
  return result;
};
export const getProfessionalInfo = async () => {
  const result = await AwsAxios.get(`${profile}/professional-info/my-info`);
  return result;
};
export const updateProfessionalInfo = async (data) => {
  const result = await AwsAxios.post(`${profile}/professional-info`, data);
  return result;
};
export const getUserMessageById = async (id) => {
  const result = await AwsAxios.get(`${profile}/message/${id}`);
  return result;
};
export const getUserUnreadMessagesCount = async (id) => {
  console.log("Al====nasjcnjacnajsjn");
  const result = await AwsAxios.get(`${utils}/user/message/unread-msg-count`);
  console.log(result, "====nasjcnjacnajsjn");

  return result;
};
export const getUserFormsDetails = async () => {
  const result = await AwsAxios.get(`${utils}/get-by-pk-sk`);
  return result;
};
export const userLogin = async (data) => {
  const result = await AwsAxios.post(`${login}/auth/signin`, data);
  return result;
};
export const updateUserFormsDetails = async (data) => {
  const result = await AwsAxios.post(`${utils}/create-by-pk-sk`, data);
  return result;
};
export const deleteByPkAndSk = async ({ pk, sk }) => {
  // const result = await AwsAxios.post(`${utils}/delete-by-pk-sk/:pk/:sk`);
  pk = encodeURIComponent(pk);
  sk = encodeURIComponent(sk);
  const result = await AwsAxios.delete(
    `${utils}/delete-by-pk-sk?PK=${pk}&SK=${sk}`
  );
  return result;
};
export const getAssessmentContents = async () => {
  const result = await AwsAxios.get(`${integrated}/get-all-assessment`);
  return result;
};
export const getAttemptAssessmentData = async (email) => {
  const result = await AwsAxios.get(`${integrated}/assessment/user/${email}`);
  return result;
};
export const addPotentialUser = async (data) => {
  const result = await AwsAxios.post(`${utils}/potential`, data);
  return result;
};
export const attemptAssessment = async (id) => {
  const result = await AwsAxios.get(`${integrated}/get-all-assessment/${id}`);
  return result;
};
export const attemptAssessmentResult = async (key, email) => {
  const result = await AwsAxios.get(
    `${integrated}/assessment/result/${key}/${email}`
  );
  return result;
};
export const getS3Media = async (data) => {
  if (typeof data === "string" && data.length > 0) {
    console.log("Hello world, Api Fileeeeeeeeeeeeeeeeee, ", data);
    const result = await AwsAxios.get(`${utils}/file/${data}`);
    return result;
  }
  return;
};
export const removeUserFromChannel = async (channelId, userId) => {
  const splitChannelId = channelId.split("#")[1];
  const splitUserId = userId.split("#")[1];
  const result = await AwsAxios.delete(
    `${utils}/channels/user/${splitChannelId}/${splitUserId}`
  );
  return result;
};
export const profileCompletion = async () => {
  const result = await AwsAxios.get(
    `https://rh8swmj6we.execute-api.us-east-2.amazonaws.com/Prod/profile-completeness`
  );
  return result;
};
export const GetCarouselData = async () => {
  const result = await AwsAxios.get(`${ApiList.utils}/carousel`);
  return result;
};
export const GetAssessmentData = async (email) => {
  const result = await AwsAxios.get(
    `${ApiList.integrated}/assessment/result/email/${email}`
  );
  return result;
};
export const getProjects = async (email) => {
  const result = await AwsAxios.get(`${ApiList.profile}/projects`);
  return result;
};
export const BugReports = async (data) => {
  const result = await AwsAxios.post(
    `${ApiList.talentProd}/talent/bug-report`,
    data
  );
  return result;
};

export const GetLiveNotificationBySME = () => {
  return AwsAxios.get(`${ApiList.talentProd}/talent/get-sme-requested-data`);
};
export const GetAllNotification = () => {
  return AwsAxios.get(`${ApiList.talentProd}/talent/notification`);
};
